module.exports = __webpack_public_path__ + "img/photo3.9edf9cf6.jpg";